module.exports = __webpack_public_path__ + "img/logo.8dbe4823.png";